/**
 * download the File
 * @param {Object} fileData
 */
export const downloadFile = async (fileData) => {
  // Check if the content is already base64 encoded
  let binaryString;
  try {
    // Convert base64 to binary string
    binaryString = atob(fileData.Content);

    // Convert binary string to array buffer
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Create blob with array buffer
    const blob = new Blob([bytes], { type: fileData.MimeType });

    // Create download link
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileData.Name;

    // Append link to body, click it, and remove it
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    // Clean up by revoking the object URL
    URL.revokeObjectURL(downloadLink.href);
  } catch (e) {
    console.error('Error processing file:', e);
  }
};
